'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { ki, Di, Ai } from './collection-economics';
import { Lr, Fr, Pr } from './apps-animation';
import { WorkbookWindow, WorkbookGrid } from './workbook-grid';
import { pe } from './business-facts';
export const ji = {
  sales: 1700,
  late: 3700,
  fabric: 5700,
};
export const Mi = [
  {
    when: 'Lowest cash under $0',
    then: 'Draw the full credit line in week 6',
    hit: (e) => e.low < 0,
  },
  {
    when: 'Gross margin under 60%',
    then: 'Reprice home basics by 5%',
    hit: (e) => e.margin < 60,
  },
  {
    when: 'EBITDA under $100k',
    then: 'Hold two FW27 styles to SS28',
    hit: (e) => e.ebitda < 100,
  },
];
export const Ni = [
  {
    w: '232px',
    xs: 'minmax(0,1fr)',
  },
  {
    w: '76px',
    xs: '58px',
    align: 'right',
  },
  {
    w: '84px',
    xs: '70px',
    align: 'right',
  },
  {
    w: '72px',
    align: 'right',
    hideSm: !0,
  },
];
export function StressTest({ t: e, onInteract: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [n, r] = React.useState(null),
    i = {
      sales: e >= (ji.sales ?? 1 / 0),
      fabric: e >= (ji.fabric ?? 1 / 0),
      late: e >= (ji.late ?? 1 / 0),
      freight: !1,
    },
    a = n ?? i,
    o = ki(a),
    s = (e) => {
      (t(),
        r({
          ...a,
          [e]: !a[e],
        }));
    },
    c = Di.some((e) => a[e.key]),
    l = (e, t, n, r, i, a, o) => {
      let s = Math.abs(n - t) > 0.05;
      return {
        cells: [
          {
            v: e,
            at: i,
          },
          {
            n: t,
            fmt: r,
            at: i + 60,
          },
          {
            v: r(n),
            at: i + 120,
            f: a,
            flashKey: r(n),
            bold: s,
            tone: s && n < t ? 'warn' : void 0,
          },
          {
            v: s ? o : '\u2014',
            tone: 'muted',
            at: i + 160,
            flashKey: o,
          },
        ],
      };
    },
    u = [
      {
        head: !0,
        cells: [
          {
            v: 'Scenario',
          },
          {
            v: 'Shock',
          },
          {
            v: '',
          },
          {
            v: '',
          },
        ],
      },
      ...Di.map((e, t) => ({
        tall: !0,
        cells: [
          {
            at: 120 + t * 90,
            node: (
              <button
                type={'button'}
                role={'checkbox'}
                aria-checked={a[e.key]}
                onClick={() => s(e.key)}
                className={
                  '-mx-2 flex h-10 w-[calc(100%+16px)] items-center gap-2 px-2 text-left hover:bg-[var(--hover-wash)]'
                }
              >
                <span
                  className={`grid size-4 shrink-0 place-items-center rounded-[4px] transition-[background-color,box-shadow] duration-150 ${a[e.key] ? 'bg-[var(--sheet-pick)] text-white' : 'shadow-[inset_0_0_0_1.5px_var(--border)]'}`}
                >
                  {translateShowcaseNode(
                    showcaseCopy,
                    a[e.key] ? (
                      <ShowcaseIcon
                        key={`${e.key}-on`}
                        name={'check'}
                        draw={'now'}
                        className={'size-3'}
                        strokeWidth={2.4}
                      />
                    ) : null
                  )}
                </span>
                <span className={'text-ink truncate'}>
                  {translateShowcaseNode(showcaseCopy, e.label)}
                </span>
              </button>
            ),
          },
          {
            v: e.shock,
            tone: a[e.key] ? void 0 : 'muted',
            at: 160 + t * 90,
          },
          {},
          {},
        ],
      })),
      {
        head: !0,
        cells: [
          {
            v: 'Plan',
          },
          {
            v: 'Base',
          },
          {
            v: 'Stressed',
          },
          {
            v: 'Change',
          },
        ],
      },
      l(
        'Revenue',
        Ai.revenue,
        o.revenue,
        Lr,
        600,
        '=Base!B2*(1+B2)',
        Lr(o.revenue - Ai.revenue)
      ),
      l(
        'Gross margin',
        Ai.margin,
        o.margin,
        Fr,
        680,
        '=Base!B3-Fabric!D4-Freight!D2',
        `${(o.margin - Ai.margin).toFixed(1)} pts`
      ),
      l(
        'EBITDA',
        Ai.ebitda,
        o.ebitda,
        Lr,
        760,
        '=C7*C8-Base!B4',
        Lr(o.ebitda - Ai.ebitda)
      ),
      l(
        'Lowest cash week',
        Ai.low,
        o.low,
        Lr,
        840,
        '=MIN(Cash!B5:N5)',
        Lr(o.low - Ai.low)
      ),
    ];
  return (
    <WorkbookWindow
      title={translateShowcaseNode(showcaseCopy, 'Stress test: FY27 plan')}
      version={'v2'}
      file={'Stress-test.sheet'}
      tabs={['Scenarios', 'Base', 'Cash', 'Contingency']}
      activeTab={0}
      formula={
        c
          ? {
              ref: 'C9',
              text: '=C7*C8-Base!B4',
              typing: !1,
            }
          : null
      }
    >
      <WorkbookGrid
        label={'Stress test'}
        columns={Ni}
        rows={u}
        t={e}
        pick={
          c
            ? {
                r: 8,
                c: 2,
              }
            : null
        }
        extra={8}
        minRows={12}
      />
      <div
        className={
          'm-2 flex flex-col gap-1.5 lg:absolute lg:top-3 lg:right-3 lg:m-0 lg:w-[284px]'
        }
      >
        <p className={'label px-1'}>
          {translateShowcaseNode(showcaseCopy, 'Contingency decisions')}
        </p>
        {translateShowcaseNode(
          showcaseCopy,
          Mi.map((e) => {
            let t = e.hit(o);
            return (
              <div
                key={e.when}
                className={`rounded-[10px] p-2.5 text-[12.5px] leading-[1.4] transition-[background-color,box-shadow] duration-300 ${t ? 'bg-[color-mix(in_oklch,var(--ref-amber)_10%,var(--background))] shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--ref-amber)_40%,transparent)]' : 'bg-[var(--background)] shadow-[var(--sh-1)]'}`}
              >
                <span className={'flex items-center justify-between gap-2'}>
                  <span className={'text-ink-3'}>
                    {translateShowcaseNode(showcaseCopy, e.when)}
                  </span>
                  <span
                    className={`num shrink-0 text-[11px] font-medium transition-colors duration-200 ${t ? 'text-[var(--ref-amber)]' : 'text-ink-4'}`}
                  >
                    {translateShowcaseNode(
                      showcaseCopy,
                      t ? 'Triggered' : 'Clear'
                    )}
                  </span>
                </span>
                <span className={'text-ink mt-0.5 block'}>
                  {translateShowcaseNode(showcaseCopy, e.then)}
                </span>
              </div>
            );
          })
        )}
        <p className={'text-ink-4 px-1 text-[12px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            'Tick a scenario to recalculate.'
          )}
        </p>
      </div>
    </WorkbookWindow>
  );
}
export const Fi = pe;
export const Ii = Fi.assumed;
export const Li = [
  {
    w: '196px',
    xs: 'minmax(0,1fr)',
  },
  {
    w: '88px',
    xs: '72px',
    align: 'right',
  },
  {
    w: '88px',
    xs: '72px',
    align: 'right',
  },
  {
    w: '120px',
    hideSm: !0,
  },
];
export const Ri = (e) => `${(e * 100).toFixed(1)}%`;
export const zi = (e) => (e === 'usd' ? Pr : Ri);
export const Bi = 4e3;
export const Vi = 6600;
export const Hi = 7200;
export const Ui = 7700;
export const Wi = (e, t, n, r, i, a = !1) => ({
  hideXs: a,
  cells: [
    {
      v: e,
      at: r,
    },
    {
      n: t,
      fmt: n,
      at: r + 60,
    },
    {},
    {
      v: i,
      at: r + 100,
      tone: 'muted',
    },
  ],
});
export const Gi = [
  '=B2*B3*(1-B6)',
  '=B9-B2*B4-B5',
  '=B10/B9',
  '=MAX(0,-MIN(Baseline!F2:F14))',
  '=Baseline!H2/B9',
];
